import LocalOffersModal from './localOffersModal'

export default LocalOffersModal